var _EmojiServiceInit_recents, _EmojiServiceInit_appendEmojiChatCommand;
import { __classPrivateFieldGet } from "tslib";
import { writable } from "svelte/store";
const MAX_RECENT_COUNT = 10;
class EmojiServiceInit {
    constructor() {
        _EmojiServiceInit_recents.set(this, writable([]));
        _EmojiServiceInit_appendEmojiChatCommand.set(this, writable());
    }
    get recents() {
        return __classPrivateFieldGet(this, _EmojiServiceInit_recents, "f");
    }
    get appendEmojiChat() {
        return __classPrivateFieldGet(this, _EmojiServiceInit_appendEmojiChatCommand, "f");
    }
    registerRecent(emoji) {
        __classPrivateFieldGet(this, _EmojiServiceInit_recents, "f").update(it => {
            const filtered = it.filter(e => e !== emoji)
                .slice(0, MAX_RECENT_COUNT - 1);
            console.log([emoji, ...filtered]);
            return [emoji, ...filtered];
        });
    }
    appendEmoji(emoji) {
        __classPrivateFieldGet(this, _EmojiServiceInit_appendEmojiChatCommand, "f").set(emoji);
    }
}
_EmojiServiceInit_recents = new WeakMap(), _EmojiServiceInit_appendEmojiChatCommand = new WeakMap();
export const EmojiService = new EmojiServiceInit();
